import React from "react";
import { createStyles } from "@mantine/core";
import useMobileAvailability from "./useMobileAvailability";

const useStyles = createStyles(() => ({
  contentArea: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignSelf: "stretch",
    padding: "32px 40px",
  },

  overlay: {
    height: "100%",
    width: "100%",
    position: "fixed",
    top: "0",
    left: "0",
    backgroundColor: "rgba(192,192,192, 0.99)",
    [`@media screen and (min-width: 600px)`]: {
      width: "0%",
      display: "none",
    },
  },
  overlayContent: {
    position: "relative",
    top: "25%",
    width: "100%",
    textAlign: "center",
    color: "white",
    display: "flex",
    alignContent: "center",
    flexDirection: "column",
    justifyContent: "center",
    [`@media screen and (min-width: 600px)`]: {
      display: "none",
    },
  },
}));

interface PageContainerProps {
  className?: string;
}
const PageContainer: React.FC<PageContainerProps> = ({
  children,
  className,
}) => {
  const { classes } = useStyles();
  const { isMobileAvailable } = useMobileAvailability();

  return (
    <section className={`${classes.contentArea} ${className ?? ""}`}>
      {!isMobileAvailable && (
        <div className={classes.overlay} style={{ zIndex: 1000 }}>
          <div className={classes.overlayContent}>
            <h2>
              <img
                src="https://www.jemhr.com/hs-fs/hubfs/Jemlogo.png?width=190&name=Jemlogo.png"
                alt="Jem Logo"
              />
            </h2>
            <h1 style={{ marginBottom: "0px" }}>We apologise,</h1>
            <p style={{ width: "75%", margin: "0 auto" }}>
              We can&apos;t show the content on smaller screens at the moment,
              Please ensure you have your device rotated to landscape, thank
              you.
            </p>
          </div>
        </div>
      )}

      {children}
    </section>
  );
};

export default PageContainer;
